<template>
  <div class="page">
    <div class="section">
      <div class="section-head">Founder</div>
      <div class="founder-list">
        <div class="cursor" @click="goDetailPage('/binwang')">
          <img class="head" :src="headwb" alt="" />
        </div>
        <div class="cursor" @click="goDetailPage('/mlfang')" >
          <img class="head" :src="headfml" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import headwb from '@/assets/people/headwb.png';
import headfml from '@/assets/people/headfml.png';

export default {
  data() {
    return {
      headwb,
      headfml,
      papers: [{
        description: 'Bahabaike Jiangtulu, Peking University, first explorer to realize the combination of the website interface and calculation of R script.',
      }, {
        description: 'Bo Peng, Nanyang Technological University, contributor to the protein-disease database from UniprotKB of E-DB',
      },{
        description: 'Peking University, main contributor to StatSurv, building web back-end and R package framework of all the available modules.',
        key: 'Changxin Lan',
        keyRouter: '/lancx'
      },{
        description: 'Fanrong Zhao, Nanyang Technological University, contributor to the chemical annotation database of E-MS and ToxCast database of E-DB.',
      },{
        description: 'Peking University, main contributor to the R package and web interface design of StatMO.',
        key: 'Guohuan Zhang',
        keyRouter: '/zhanggh'
      },{
        description: 'Peking University, main contributor to the R package and web interface design of StatMedt.',
        key: 'Mengyuan Ren',
        keyRouter: '/renmy'
      },{
        description: 'Min Nian, Fudan University, main contributor to the meta-analysis database of E-META module.',
      },{
        description: 'Peking University, main contributor to the R package and web interface design of E-VIZ, and the visualization of most modules.',
        key: 'Ning Gao',
        keyRouter: '/gaon'
      },{
        description: 'Peking University, main contributor to the R package and web interface design E-META, and the united ID coding of chemicals, proteins, and diseases of E-DB.',
        key: 'Weinan Lin',
        keyRouter: '/linwn',
      },{
        description: 'Tianxiang Wu, Peking University, contributor to E-DB and platform maintenance.',
      },{
        description: 'Xiaotong Ji, Fudan University, contributor to the chemical-protein database of E-DB.',
        key: '',
        keyRouter: ''
      },{
        description: 'Xiaojia Chen, Fudan University, contributor to the chemical-protein database of E-DB.',
      },{
        description: 'Xuqiang Shao and his graduate students (Mingyu Li, Baiqiang Li, Yizhong Jin, Siqing Zhang), North China Electric Power University, providing the network technology support.',
      },{
        description: 'Peking University, main contributor to the R package and web interface design of StatDesc, and the preliminary R code of StatMix.',
        key: 'Yanqiu Feng',
        keyRouter: '/fengyq'
      },{
        description: 'Yuting Wang, Peking University, contributor to the R package and web interface design of StatMO.',
      },{
        description: 'Zhijian Liu, North China Electric Power University, consultant expert.',
      }]
    };
  },
  methods: {
    goDetailPage(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  overflow: auto;
  margin-left: 30px;
}
.section {
  text-align: left;
  padding: 20px 30px;
}
.section-head {
  font-size: $webpage-large-font-size;
  font-weight: 600;
  margin-bottom: 10px;
  display: flex;
}
.founder-list {
  display: flex;
  padding-left: 40px;
  gap: 100px;
}
.cursor {
  cursor: default;
}
.head {
  width: 230px;
  height: 400px;
}
.paper-list {
  margin-left: 30px;
  display: flex;
}
.content {
  word-break: break-word;
  overflow: hidden;
  line-height: $line-height-x-large;
  font-size: $webpage-base-font-size;
}
.name-span {
  font-weight: 600;
}
.name-span:hover {
  color: $blue
}
@media screen and (max-width: 600px) {
  .founder-list {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    gap: 10px;
  }
  .paper-list {
    margin-left: 0;
    display: flex;
  }
}
</style>
